<template>
  <div class="main">
    <!-- <div class="login-page">
      <div class="login-page-content">
        <div class="login-box">
          <div class="login-box-left">
            <div class="login-title">
              <img src="../../assets/images/zwy-logo.png" class="logo">
            </div>
            <div style="width:100%;padding:20px">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                <el-form-item label="" prop="username">
                  <el-input v-model="ruleForm.username" placeholder="请输入用户名" prefix-icon="el-icon-s-custom"></el-input>
                </el-form-item>
                <el-form-item label="" prop="pwd">
                  <el-input type="password" v-model="ruleForm.pwd" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
                </el-form-item>
                <el-form-item prop="region" style="margin-bottom:0">
                  <el-button type="primary" @click="commit('ruleForm')" style="width:100%" :loading="loading">立即登录</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="login-box-right"></div>
        </div>
      </div>
    </div> -->
    <div class="login-page">
      <div class="login-page-content">
        <div class="login-box">
          <div class="login-title">用户邀请系统</div>
          <div style="margint-top: 10px">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" size="medium">
              <el-tabs v-model="activeName">
                <!-- <el-tabs v-model="activeName" @tab-click="handleTabClick"> -->
                <!-- <el-tab-pane label="账号密码登录" name="2"> -->
                <div class="login-form-box">
                  <el-form-item label="" prop="username">
                    <el-input v-model="ruleForm.username" placeholder="请输入手机号/用户名" prefix-icon="el-icon-s-custom"></el-input>
                  </el-form-item>

                  <el-form-item label="" prop="pwd">
                    <el-input type="password" v-model="ruleForm.pwd" placeholder="请输入密码" prefix-icon="el-icon-lock"> </el-input>
                  </el-form-item>

                  <el-form-item label="" prop="imgCode">
                    <el-input style="width: 50%;" v-model="ruleForm.imgCode" placeholder="请输入验证码" prefix-icon="el-icon-postcard"> </el-input>
                    <!-- <el-input style="width: 40%; margin-left: 10px;" v-model="ruleForm.pwd">  -->

                    <img-verify-com style="margin-left: 60%; margin-top: -12%;" ref="imgVerifyCom" />

                  </el-form-item>

                
                </div>
                <div class="ys_rem_for" style="margin-top: 0px">
                  <el-checkbox v-model="ruleForm.remember_me">
                    记住我
                  </el-checkbox>
                  <span class="ys_send_again" @click="forget_password_visible = true">忘记密码？</span>
                </div>
                <!-- </el-tab-pane> -->
                <!-- <el-tab-pane label="验证码登录" name="1">
									<div class="login-form-box" v-if="activeName == 1">
										<el-form-item label="" prop="username">
											<el-input v-model="ruleForm.username" placeholder="请输入手机号" prefix-icon="el-icon-s-custom"></el-input>
										</el-form-item>
										<el-form-item label="" prop="verify_code">
											<el-row :gutter="10">
												<el-col :md="16" :sm="15" :xs="13">
													<el-input v-model="ruleForm.verify_code" placeholder="请输入验证码" prefix-icon="el-icon-s-promotion"></el-input>
												</el-col>
												<el-col :md="8" :sm="9" :xs="11">
													<el-button type="primary" size="medium" style="width: 100%" :disabled="time_dec > 0" @click="sendVerifyCode">
														<span v-show="time_dec <= 0">发送验证码</span>
														<span v-show="time_dec > 0">{{ time_dec }}S后重发</span>
													</el-button>
												</el-col>
											</el-row>
										</el-form-item>
									</div>
								</el-tab-pane> -->
                <!-- <el-tab-pane label="微信扫码登录" name="3">
									<div class="login-form-box" v-if="activeName == 3" style="margin-top: 10px" v-loading="qr_loading">
										<div class="login-qrcode-container">
											<div class="login-qrcode">
												<img :src="qrcode_url" />
											
												<div class="qrcode-login-success" v-show="qrcode_login_success">
													<div class="qrcode-login-success-icon">
														<i class="el-icon-success qr-icon-success"></i>
													</div>
												</div>
											</div>

											<div>
												<span @click="getQrcode(true)">
													<el-link type="primary" href="javascript:;" style="margin-bottom: 10px"><i class="el-icon-refresh"></i>刷新二维码</el-link>
												</span>
											</div>
											<div style="padding-left: 10px">请打开微信"扫一扫"</div>
										</div>
									</div>
								</el-tab-pane> -->
              </el-tabs>

              <el-form-item prop="region" style="margin-bottom: 0; margin-top: 40px" v-if="activeName != 3">
                <el-button type="primary" size="medium" @click="commit('ruleForm')" style="width: 100%" :loading="loading">立即登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/utils/store";
// import initGeetest from "../../assets/js/gt.js";
// import Vue from "vue";
import imgVerifyCom from './ValidCode.vue'//导入子组件
export default {
  name: "Login",
  components: {
    [imgVerifyCom.name]: imgVerifyCom,
  },
  data() {
    return {
      show_username_tips: false,
      show_pwd_tips: false,
      loading: false,
      forget_password_visible: false,
      ruleForm: {
        username: "",
        pwd: "",
        verify_code: "",
        imgCode:"",
      },

      qrcode_url: "", //扫码登录图片路径
      connecting: false, //当前是否处于正在连接状态
      qr_loading: false,
      tag: "",
      qrcode_login_success: false, //是否扫码成功
      heart_timehander: false,

      rules: {
        username: [{ required: true, message: "请输入手机号/用户名", trigger: "change" }],
        pwd: [{ required: true, message: "请输入密码", trigger: "change" }],
        verify_code: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },

      activeName: "2",

      sms_init: false,
      captchaObj: {},
      geetest_challenge: "",
      geetest_validate: "",
      geetest_seccode: "",
      time_dec: 0,

    };
  },

  mounted() {
    // this.smsInit();

    //按enter键进行登录
    window.addEventListener("keydown", this.handleEnterLogin);
  },

  watch: {
    username(val) {
      if (val) {
        this.show_username_tips = false;
      }
    },
    pwd(val) {
      if (val) {
        this.show_pwd_tips = false;
      }
    },
  },

  methods: {
    //初始化短信验证
    // smsInit() {
    // 	this.$_invoke("sms_init", {}).then((data) => {
    // 		initGeetest(
    // 			{
    // 				gt: data.gt,
    // 				challenge: data.challenge,
    // 				new_captcha: data.new_captcha,
    // 				product: "bind",
    // 				offline: !data.success,
    // 			},
    // 			(captchaObj) => {
    // 				this.captchaObj = captchaObj;
    // 				this.sms_init = true;
    // 			}
    // 		);
    // 	});
    // },

    //发送验证码
    // sendVerifyCode() {
    // 	this.$refs.ruleForm.validateField("username", (valid) => {
    // 		if (!valid) {
    // 			this.captchaObj.verify();
    // 			this.captchaObj.onSuccess(() => {
    // 				var result = this.captchaObj.getValidate();
    // 				this.$_invoke("sms_sendLoginVerify", {
    // 					mobile: this.ruleForm.username,
    // 					geetest_challenge: result.geetest_challenge,
    // 					geetest_validate: result.geetest_validate,
    // 					geetest_seccode: result.geetest_seccode,
    // 				})
    // 					.then(() => {
    // 						this.$_msg.success("短信发送成功");
    // 						this.time_dec = 60;
    // 						this.timeDec();
    // 					})
    // 					.catch((e) => {
    // 						// console.log(e);
    // 					})
    // 					.finally(() => {
    // 						this.loading = false;
    // 					});
    // 			});
    // 		}
    // 	});
    // },

    // //倒计时
    // timeDec() {
    // 	if (this.time_dec <= 0) {
    // 		return;
    // 	}
    // 	setTimeout(() => {
    // 		this.time_dec--;
    // 		this.timeDec();
    // 	}, 1000);
    // },

    // //切换登录方式
    // handleTabClick(e) {
    // 	if (e.name == 3) {
    // 		//扫码登录
    // 		this.getQrcode();
    // 	}
    // },

    // //获取微信二维码
    // getQrcode(reload = false) {
    // 	//在强制刷新和未生成二维码时才进行生成
    // 	if (reload || !this.qrcode_url) {
    // 		this.qr_loding = true;
    // 		this.$_invoke("session_getLoginQrcode").then((ret) => {
    // 			this.qrcode_url = ret.qrcode_url;
    // 			this.tag = ret.tag;

    // 			this.qr_loding = false;

    // 			//如果已经连接，先断开连接，再重新连接，重新发送一个tag作为当前连接的ID
    // 			if (this.ws != false) {
    // 				this.ws.close();
    // 			}
    // 			this.createWebsocket();
    // 		});
    // 	}
    // },

    // //启动websocket监听微信小程序端是否点击了确认登录
    // createWebsocket() {
    // 	this.ws = new WebSocket(Vue.$_config.login_websocket_url);

    // 	//连接成功事件
    // 	this.ws.onopen = () => {
    // 		// console.log("连接成功了");
    // 		//连接成功，发送消息，设置uid
    // 		this.ws.send(JSON.stringify(this.tag + "_pc_login"));

    // 		//心跳,防止断开连接
    // 		this.wsHeartBreak();
    // 	};

    // 	this.ws.onmessage = (evt) => {
    // 		const data = JSON.parse(evt.data);
    // 		if (data.event == "qrcode_login" && data.tag == this.tag) {
    // 			this.qrcode_login_success = true;
    // 			this.$_msg.success("登录成功");
    // 			store.set("token", data.token);
    // 			this.$router.push("/admin/home");
    // 		}
    // 	};

    // 	this.ws.onclose = () => {
    // 		//断开连接时进行重连
    // 		this.wsReconnect();
    // 		// console.log("Connection closed.");
    // 	};
    // },

    // //websocket心跳
    // wsHeartBreak() {
    // 	if (this.heart_timehander) {
    // 		clearTimeout(this.heart_timehander);
    // 	}
    // 	this.heart_timehander = setTimeout(() => {
    // 		this.ws.send("ping");
    // 		this.wsHeartBreak();
    // 	}, 6000);
    // },

    // //wesocket断线重连
    // wsReconnect() {
    // 	if (this.connecting) return;
    // 	this.connecting = true;
    // 	setTimeout(() => {
    // 		this.connecting = false;
    // 		this.createWebsocket();
    // 	}, 300);
    // },

    //按enter键登录
    handleEnterLogin(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13 && (this.activeName == "1" || this.activeName == "2")) {
        this.commit("ruleForm");
      }
    },

    //登录
    commit(formName) {

      if(this.ruleForm.imgCode != this.$refs.imgVerifyCom.imgCode){
        this.$_msg.error("验证码不正确！")
        return;
      }
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //发起登录请求
          this.loading = true;
          let method = "login_login";
          if (this.activeName == 1) {
            //短信验证码登录
            method = "session_smsLogin";
          }
          this.$_invoke(method, this.ruleForm)
            .then((res) => {
           
              // console.log(res)
           
              this.$_msg.success("登录成功");
              store.set("token", res.token);
              if(res.username.corp_pid != "2"){
                this.$router.push("/admin/app_user");
              }else{
                this.$router.push("/admin/home");
              }
              //销毁按钮事件
              window.removeEventListener("keydown", this.handleEnterLogin, false);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: block;

  .login-page {
    @include common-box-sizing();
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    background: rgb(152, 152, 154);
    overflow: auto;

    background-image: url("../../assets/images/bg@2x.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // -webkit-filter: blur(15px); //模糊
    // -moz-filter: blur(15px); //模糊
    // -o-filter: blur(15px); //模糊
    // -ms-filter: blur(15px); //模糊
    // filter: blur(15px); //模糊

    .login-page-content {
      @include common-box-sizing();
      min-height: 600px;
      height: calc(100% - 40px);

      .login-box {
        position: absolute;
        right: 100px;
        top: 50%;
        left: 51%;
        margin-left: -250px;
        margin-top: -250px;
        height: 500px;
        width: 460px;
        padding: 0 50px;
        background: #fff;
        @include border-radius(10px);
        @include box-shadow(0 1px 3px rgba(0, 0, 0, 0.1));

        ::v-deep .el-tabs__nav-wrap::after {
          background-color: transparent;
        }

        // ::v-deep .el-tabs__item.is-active {
        // 	color: #0c87ff;
        // }

        // ::v-deep .el-tabs__active-bar {
        // 	background-color: #0c87ff;
        // }

        ::v-deep .el-tabs__item {
          font-size: 16px;
        }

        .login-title {
          font-size: 25px;
          margin-bottom: 25px;
          font-weight: bold;
          color: $font-color-light;
          text-align: center;
          color: #333333;
          margin-top: 20px;
        }

        ::v-deep .el-tabs__item {
          color: #aaaaaa;
        }

        ::v-deep .el-tabs__item.is-active {
          color: $primary-color;
        }

        .login-form-box {
          margin-top: 10px;

          ::v-deep .el-form-item {
            margin-bottom: 30px;
          }
          ::v-deep .el-input--medium .el-input__inner {
            height: 45px;
            line-height: 45px;
            font-size: 15px;
          }

          ::v-deep .el-input--medium .el-input__icon {
            font-size: 18px;
            margin-top: 2px;
          }
        }

        ::v-deep .el-button {
          padding: 14px 20px;
        }
      }

      .login-qrcode {
        position: relative;
      }

      .login-qrcode-container {
        text-align: center;
        width: auto;
      }
      .ys_rem_for {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .ys_send_again {
        color: $primary-color;
        cursor: pointer;
      }
      .qrcode-login-success {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(255, 255, 255, 0.5);
        display: table;
        width: 100%;
        height: 100%;

        .qrcode-login-success-icon {
          text-align: center;
          display: table-cell;
          vertical-align: middle;
          .qr-icon-success {
            font-size: 50px;
            color: $success-color;
          }
        }
      }
    }
  }
}

.logo {
  vertical-align: middle;
  width: 200px;
  margin-right: 10px;
}
</style>
